<template>
  <CustomCreateDialog
    dialogTitle="ایجاد تایم کار در منزل جدید"
    dialogId="create-homework-time-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCreateTimeForHomeworkRequest"
  >
    <BCol cols="12">
      <CustomDatePicker
        inputId="newHomeworkTimePayloadDate"
        @getSelectedDate="setHomeworkPayloadDate"
        inputLabel="تاریخ زمان کار در منزل"
        inputPlaceholder="1403/06/05"
      ></CustomDatePicker>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        type="number"
        inputmode="numeric"
        isText
        customRules="required|min:1"
        inputId="newHomeworkTimePayloadTime"
        inputLabel="مدت زمان بازه"
        inputPlaceholder="10"
        v-model="newHomeworkTimePayload.masterTimeByMinute"
      >
        <template #append> دقیقه </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12">
      <TextInput
        inputId="homeworkDescription"
        inputLabel="توضیحات"
        inputPlaceholder="این زمان..."
        v-model="newHomeworkTimePayload.description"
      ></TextInput>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      newHomeworkTimePayload: {
        masterUserId: null,
        date: null,
        masterTimeByMinute: 0,
        description: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setHomeworkPayloadDate(homeworkDate) {
      if (homeworkDate) {
        this.newHomeworkTimePayload.date = new Date(homeworkDate).toISOString();
      } else {
        this.newHomeworkTimePayload.date = null;
      }
    },
    async sendCreateTimeForHomeworkRequest() {
      try {
        this.newHomeworkTimePayload.masterUserId = getUserData().user.userId;
        this.isOkButtonDisabled = true;
        let _this = this;
        let createTimeForHomework = new CreateTimeForHomework(_this);
        createTimeForHomework.setRequestParamDataObj(
          _this.newHomeworkTimePayload
        );
        await createTimeForHomework.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "زمان کار در منزل با موفقیت ایجاد شد.",
              },
            });
            _this.newHomeworkTimePayload = {
              masterUserId: null,
              date: null,
              masterTimeByMinute: 0,
              description: null,
            };
            this.$bvModal.hide("create-homework-time-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    CustomDatePicker,
    CustomAppendText,
    TextInput,
    BCol,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
import { CreateTimeForHomework } from "@/libs/Api/HomeWorks";
</script>
